
import Footer from "./Footer";
import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import { motion, useInView } from "framer-motion";




const AboutTab = () => {

    const isMobile = useMediaQuery("(max-width: 900px)");

   

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when component loads
  }, []);



    const cardData = [
        {
          title: "Be You",
          description: "Express your true self. Show integrity. Embrace diversity.",
        },
        {
          title: "Be Inspirational",
          description: "Show enthusiasm. Uplift others. Give back.",
        },
        {
          title: "Be Extraordinary",
          description: "Stay hungry. Be always curious. Make an impact.",
        },
        {
          title: "Be Bold",
          description: "Stand up. Lead change. Set the new standard.",
        },
      ];
    
        useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);

       const sectionRef = useRef(null);
       const isInView = useInView(sectionRef, { triggerOnce: false }); 

          


return (
    <>
      {/* First Section - Background Image */}
      <Box
      
        sx={{
          textAlign: "center",
         
          minHeight: "40vh",
          width: "100vw",
          backgroundImage: isMobile ?`url("/image/about10.jpg")`:`url("/image/about9.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          paddingTop: "80px", // Ensure there's space for header
          
        }}
      ></Box>

      {/* 2nd Section - Background Image */}
      <Box
  sx={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: "center",
    justifyContent: "center",
    width: "90%",
    padding: isMobile ? "30px 20px" : "50px 50px",
    gap: isMobile ? "30px" : "50px", // Add spacing in mobile view to prevent overlap
    boxSizing: "border-box",
    marginLeft: isMobile ? "20px" : "1in",
    marginRight: isMobile ? "10px" : "1in",
    height: isMobile ? "auto" : "100vh", // Auto height in mobile to prevent forced overlap
    paddingTop: isMobile ? "80px" : "220px",
    marginBottom: isMobile ? "80px":"400px",
  }}
>
  {/* Left Content */}
  <Box
    sx={{
      flex: 1,
      textAlign: isMobile ? "center" : "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      height: "100%",
    }}
  >
    <Typography variant="h3" sx={{ fontSize: isMobile ? "50px" : "130px" }}>
      Our Mission 
    </Typography>
    <Typography variant="h3" sx={{ fontSize: isMobile ? "50px" : "130px" ,textAlign:"right"}}>
       Our Vision
    </Typography>

    <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
      Tech Informatic Solutions is the world leader in digital platform cybersecurity,
      empowering businesses to innovate for a secure, connected future.
    </Typography>

    <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
      Building on over 5 years of expertise in security, Tech Informatic Solutions services
      and solutions protect revenue, enable growth and fight cybercrime in
      video entertainment, video games, and connected industries including
      transport and infrastructure.
    </Typography>

    <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
      With teams around the world, Tech Informatic Solutions greatest asset is its people and
      diversity is celebrated through an inclusive workplace, where everyone
      has an equal opportunity to drive innovation and support Tech Informatic Solutions
      success. Tech Informatic Solutions is the preferred security partner to empower a secure
      world where people can connect with confidence.
    </Typography>
  </Box>

  {/* Right Image */}
  <Box
    sx={{
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: isMobile ? "auto" : "100%", // Prevents forced height in mobile view
    }}
  >
    <img
      src="/image/about1stimage.jpg" // Replace with actual image URL
      alt="About Us"
      style={{
        width: isMobile ? "90%" : "100%", // Adjust width for balance
        maxWidth: "100%", // Ensures image does not exceed container width
        height: isMobile ? "auto" : "100%", // Keeps aspect ratio on mobile
        objectFit: "cover",
        borderRadius: "10px",
        boxShadow: `
          0px 12px 25px rgba(0, 0, 0, 0.6),  
          inset 0px 10px 20px rgba(255, 255, 255, 0.15),
          inset 0px -10px 30px rgba(0, 0, 0, 0.7),
          inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
          inset -10px 0px 20px rgba(255, 255, 255, 0.2)
        `,
      }}
    />
  </Box>
</Box>





<Box
      ref={sectionRef}
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        position: "relative",
        padding: { xs: "20px", md: "50px" },
        boxSizing: "border-box",
        fontFamily: "'Roboto', sans-serif",
        overflow: "hidden",
        paddingTop: "150px", 
        marginTop:"50px",
     //  paddingTop:  isMobile ? "300px" : "500px",
      }}
    >
      {/* White Section (1/4th of the screen) */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: { xs: "100%", md: "25%" },
          height: { xs: "30vh", md: "100%" },
          backgroundColor: "#f9f9f9",
        }}
      />

      {/* Blue Section (3/4th of the screen) */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: { xs: 0, md: "25%" },
          width: { xs: "100%", md: "75%" },
          height: { xs: "100vh", md: "100%" },
          background: "linear-gradient(to right, #E0F7FA, #B2EBF2, #80DEEA)",
          padding: { xs: "20px", md: "50px" },
          boxSizing: "border-box",
          borderBottomLeftRadius:"100%",
          
        }}
      />

      {/* Content Area */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "1300px",
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: { xs: "60px", md: "100px" },
        }}
      >
        {/* Title Section */}
        <Typography
          variant="h4"
          sx={{
            color: "#424242",
            fontWeight: "bold",
            textAlign: "left",
            marginBottom: "20px",
            fontSize: isMobile ? "50px" : "130px"
          }}
        >
          Our Values
        </Typography>
        <Typography
          variant="h4"
          sx={{
            color: "#424242",
            fontWeight: "bold",
            textAlign: "left",
            marginBottom: "20px",
            fontSize: isMobile ? "30px" : "50px"
          }}
        >
          Adhere to the highest professional standards
        </Typography>

        {/* Description Section */}
        <Typography
          variant="body1"
          sx={{
            color: "#616161",
            textAlign: "left",
            maxWidth: "100%",
            marginBottom: "40px",
            lineHeight: 1.6,
            fontSize: { xs: "1rem", md: "1.2rem" },
          }}
        >
      Put client interests ahead of our firm’s
maintain high standards and conditions for client service
observe high ethical standards
preserve client confidences
maintain an independent perspective
manage client and firm resources cost-effectively   </Typography>
<Typography
          variant="h4"
          sx={{
            color: "#424242",
            fontWeight: "bold",
            textAlign: "left",
            marginBottom: "20px",
            fontSize: isMobile ? "30px" : "50px"
          }}
        >
         Improve our clients’ performance significantly
        </Typography>

        {/* Description Section */}
        <Typography
          variant="body1"
          sx={{
            color: "#616161",
            textAlign: "left",
            maxWidth: "100%",
            marginBottom: "40px",
            lineHeight: 1.6,
            fontSize: { xs: "1rem", md: "1.2rem" },
          }}
        >
      Follow the top-management approach
pursue holistic impact
use our global network to deliver the best of our firm to all clients
bring innovations in management practice to clients
build client capabilities to sustain improvement
build enduring relationships based on trust  </Typography>
<Typography
          variant="h4"
          sx={{
            color: "#424242",
            fontWeight: "bold",
            textAlign: "left",
            marginBottom: "20px",
            fontSize: isMobile ? "30px" : "50px"
          }}
        >
         Create an unrivaled environment for exceptional people
        </Typography>

        {/* Description Section */}
        <Typography
          variant="body1"
          sx={{
            color: "#616161",
            textAlign: "left",
            maxWidth: "100%",
            marginBottom: "40px",
            lineHeight: 1.6,
            fontSize: { xs: "1rem", md: "1.2rem" },
          }}
        >
      Be non-hierarchical and inclusive
sustain a caring meritocracy
develop one another through apprenticeship and mentoring
uphold the obligations to engage and dissent
embrace diverse perspectives with curiosity and respect
govern ourselves as a “one firm” partnership </Typography>



       {/* Cards Section */}
       <Box
  sx={{
    width: "100%",
    display: "flex",
    flexDirection: isMobile ? "column" : "row",  // Mobile: column | Desktop: row
    alignItems: "center",
    justifyContent: isMobile ? "center" : "space-between",
    gap: { xs: "20px", md: "30px" },  // Adjust spacing
    
  }}
>
  {/* Map through the cards */}
  {cardData.map((card, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Resets when out of view
          transition={{ duration: 0.5, delay: index * 0.9 }}
          style={{ flex: "0 0 250px" }}
        >
      <Box
        sx={{
          width: "250px",  // Fixed width for all cards
          minHeight: "250px",
         // backgroundColor: "#ffffff",
         background: "radial-gradient(circle, #1F6788, #161623)",
          borderRadius: "15px",
          padding: "20px",
          textAlign: "left",
          boxSizing: "border-box",
          boxShadow: `
            0px 12px 25px rgba(0, 0, 0, 0.6),  
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7),
            inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
            inset -10px 0px 20px rgba(255, 255, 255, 0.2)
          `,
        }}
      >
              {/* Description Title */}
              
              <Typography
                variant="h6"
                sx={{
            
                  fontWeight: "bold",
                  fontSize: "2rem",
                  marginBottom: "10px",
               
              //flexWrap: "nowrap",
                }}
              >
               <span style={{  WebkitBackgroundClip: "text", color: "white" }}>{card.title}</span>  
              </Typography>

              {/* Description Text */}
              <Typography
                variant="body2"
                sx={{
                  color: "white", 
                  fontSize: "1rem",
                  lineHeight: 1.5,
                }}
              >
                {card.description}
              </Typography>
           </Box>
            </motion.div>
          ))}
        </Box>
      </Box>
    </Box>




 
    {/* 4th Section - Background Image */}

    <Box
  sx={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: "center",
    justifyContent: "center",
    width: "70%",
    padding: isMobile ? "30px 20px" : "50px 50px",
    gap: "50px", // Reduce gap to prevent excessive spacing
    boxSizing: "border-box",
    marginLeft: isMobile ? "60px" : "3in",
    marginRight: isMobile ? "60px" : "3in",
    minHeight: isMobile ? "auto" : "100vh", // Use minHeight instead of fixed height
    paddingTop: isMobile ? "80px" : "100px", // Reduce paddingTop to prevent overlap
    marginBottom: isMobile ? "100px" : "0px", // Increase space to avoid overlap
  }}
>
  {/* Left Content */}
  <Box
    sx={{
      flex: 1,
      textAlign: isMobile ? "center" : "left",
      margin: "0px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    }}
  >
    <Typography
      variant="h3"
      sx={{
        fontSize: isMobile ? "50px" : "130px", // Reduce heading size for mobile
      }}
    >
      How We Work
    </Typography>

    <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
    In that time, we’ve seen a lot of mystique and jargon associated with consulting firms. We’re out to break down those barriers. We won’t quote you a list of cutting-edge solutions and expect you to keep yourself afloat in a rapidly evolving tech landscape. We’ll just…talk to you. We partner with you to create a blueprint of impactful, lasting value—and that blueprint always starts with consulting.   </Typography>

    <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
    Our consultative approach allows our experts to learn what makes your organization tick, and how to deliver the best solutions for memorable user experiences. From here, we map the projects, tools, and prototypes to turn your great ideas into reality. But whatever we do begins and ends with the people who use your data and tech.    </Typography>
  </Box>

  {/* Right Image */}
  <Box
    sx={{
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0px",
      minHeight: "auto", // Prevents height issues
      marginTop: isMobile ? "50px" : "0px", // Reduced for better alignment
    }}
  >
    <img
      src="/image/employee.jpg"
      alt="About Us"
      style={{
        width: isMobile ? "90%" : "100%",
        maxHeight: "100%",
        objectFit: "cover",
        borderRadius: "10px",
        boxShadow: `
          0px 12px 25px rgba(0, 0, 0, 0.6),  
          inset 0px 10px 20px rgba(255, 255, 255, 0.15),
          inset 0px -10px 30px rgba(0, 0, 0, 0.7),
          inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
          inset -10px 0px 20px rgba(255, 255, 255, 0.2)
        `,
      }}
    />
  </Box>
</Box>

 
{/* 5th Section - Background Image */}
<Box
  sx={{
    width: "100%",
    minHeight: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    position: "relative",
    padding: { xs: "20px", md: "50px" },
    boxSizing: "border-box",
    fontFamily: "'Roboto', sans-serif",
    overflow: "visible",
    paddingTop: "150px",
    marginTop: "50px",
    background: "radial-gradient(circle, #1F6788, #161623)",
  }}
>
  <Box
    sx={{
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      padding: isMobile ? "30px 20px" : "50px 30px",
      boxSizing: "border-box",
      minHeight: "auto",
      margin: "0 auto",
    }}
  >
    {/* Left Content (Images) */}
    <Box
      sx={{
        width: isMobile ? "100%" : "25%",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center", // ✅ Center images in mobile view
        gap: isMobile ? "20px" : "20px", // ✅ Space between images
        marginBottom: isMobile ? "30px" : "0px", // ✅ Add space between images & heading in mobile
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isMobile ? "20px" : "20px",
          alignItems: "center", // ✅ Center align images
          width: "100%",
        }}
      >
        <img
          src="/image/diversity1.jpg"
          alt="Diversity 1"
          style={{
            width: "80%",
            borderRadius: "10px",
            boxShadow: "0px 12px 25px rgba(0, 0, 0, 0.6)",
          }}
        />
        <img
          src="/image/diversity2.jpg"
          alt="Diversity 2"
          style={{
            width: "80%",
            borderRadius: "10px",
            boxShadow: "0px 12px 25px rgba(0, 0, 0, 0.6)",
          }}
        />
        <img
          src="/image/clap.jpg"
          alt="Diversity 3"
          style={{
            width: "80%",
            borderRadius: "10px",
            boxShadow: "0px 12px 25px rgba(0, 0, 0, 0.6)",
          }}
        />
      </div>
    </Box>

    {/* Right Content (Text) */}
    <Box
      sx={{
        width: isMobile ? "100%" : "75%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: isMobile ? "center" : "flex-start",
        textAlign: isMobile ? "center" : "left",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: isMobile ? "50px" : "100px",
          color: "white",
          marginBottom: "10px",
          lineHeight: "1.1",
          
        }}
      >
        Our Commitment to Diversity, Equity, and Inclusion
      </Typography>
      <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "white" }}>
        A diverse, equitable, and inclusive culture makes our business thrive.
      </Typography>
      <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "white" }}>
        We’re committed to fostering a company culture that values people for
        their individual experiences, backgrounds, and differences. We’ve
        developed a committee devoted to continuously ensuring that DEI
        initiatives are built into the fabric of our organization.
      </Typography>
      <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "white" }}>
        Launch is an equal opportunity employer and practices not to
        discriminate against any employee or applicant because of race, color,
        age, national origin, religion, gender, gender identity or expression,
        sexual orientation or preference, pregnancy or maternity, marital
        status, physical or mental disability, medical condition, veteran
        status, citizenship, or any other basis protected by laws or
        regulations in the locations where we do business.
      </Typography>
      <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "white" }}>
        If you’re equally committed to a culture where diversity and inclusion
        are celebrated, come work with us!
      </Typography>
    </Box>
  </Box>

  {/* Add Extra Margin to Prevent Footer Overlapping */}
  <Box sx={{ marginBottom: "100px" }} />

</Box>

{/* Footer */}
<Footer />

    </>
  );
};

export default AboutTab;
